import { createSlice } from '@reduxjs/toolkit'
import React from 'react';

const defaultData = {
  shopCode: '',
  isOwner: true,
  firstName: '',
  lastName: '',
  email: '',
  shopId: null,
  name: '',
  birthDate: null,
  line: null,
  mobileNumber: null,
  address: '',
  subDistrict: null,
  subDistrictId: null,
  amphoe: '',
  amphoeId: null,
  province: '',
  provinceId: null,
  zipCode: '',
  isDeliveryAddress: false,
  deAddress: '',
  deSubDistrict: '',
  deSubDistrictId: null,
  deAmphoe: '',
  deAmphoeId: null,
  deProvince: '',
  deProvinceId: null,
  deZipCode: '',
};

export const RegisterShopSlice = createSlice({
  name: 'RegisterShop',
  initialState: defaultData,
  reducers: {
    setRegisterShop: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        state[key] = value;
      }
    },
    resetRegisterShop: () => defaultData
  },
})

// Action creators are generated for each case reducer function
export const {
  setRegisterShop,
  resetRegisterShop
} = RegisterShopSlice.actions

export default RegisterShopSlice.reducer